module.exports = __webpack_public_path__ + "static/media/Feature2_svg.a1f015cd.svg";